import React from 'react'
import { productUrl } from '@helpers/route'
import { styled } from '@mui/material/styles'
import { useTest } from '@hooks/useTest'
import { addToDataLayer_nextgen } from '@helpers/google-tag-manager'
import { Link } from 'gatsby'
import Button from '../../../../@rtg2022/components/atoms/Button/Button'
import { useBaseCollectionTileContext } from '../BaseCollectionTileContext'

const StyledCtaWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
  [theme.breakpoints.up('md')]: {
    flexWrap: 'nowrap',
    gap: '16px',
  },
}))

const StyledButton = styled(Button)(({ theme }) => ({
  fontSize: '15px',
  fontWeight: 600,
  width: '100%',
  boxShadow: 'none',
  // padding: '8px 16px',
  '&:hover': {
    boxShadow: 'none',
  },
  [theme.breakpoints.up('md')]: {
    width: '100%',
  },
  zIndex: 1,
}))

const StyledFullCollectionButton = styled(StyledButton)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    width: '188px',
    minWidth: '188px',
  },
}))

const ShopButton = () => {
  const { collection, activeColor } = useBaseCollectionTileContext()
  const { baseRoute, PLPRoute, title, variations, collection: collectionName } = collection ?? {}
  const { generateTestId } = useTest()
  const route = variations?.[activeColor]?.route ?? baseRoute
  const productData = variations?.[activeColor]?.productData
  const fullCollectionRoute =
    PLPRoute || (collectionName ? `/search/?page=1&query=${encodeURIComponent(collectionName)}` : null)

  return (
    <StyledCtaWrapper>
      {route && (
        <StyledButton
          variant="contained"
          color="primary"
          href={productUrl(route)}
          aria-label={`Shop the ${title || 'collection'}`}
          title={`View ${title || 'collection'} details`}
          data-testid={generateTestId('collection-tile', 'shop-the-room-set')}
          onClick={() => {
            addToDataLayer_nextgen('ee_click', {
              ecommerce: {
                click: {
                  products: [
                    {
                      ...productData,
                    },
                  ],
                },
              },
              clp_action: 'Collection Tile Card Click',
              clp_collection: title,
            })
          }}
        >
          Shop The Room Set
        </StyledButton>
      )}
      {fullCollectionRoute && (
        <Link to={fullCollectionRoute} style={{ width: '100%', flex: 1 }}>
          <StyledFullCollectionButton
            variant="text"
            color="primary"
            aria-label={`Shop the ${title || 'collection'}`}
            title={`View ${title || 'collection'} details`}
            data-testid={generateTestId('collection-tile', 'view-full-collection')}
            onClick={() => {
              addToDataLayer_nextgen('clp_interaction', {
                event: 'clp_interaction',
                clp_action: 'View Full Collection Button',
                clp_collection: title,
              })
            }}
          >
            View Full Collection
          </StyledFullCollectionButton>
        </Link>
      )}
    </StyledCtaWrapper>
  )
}

export default ShopButton
